import polygonDialog from "./polygonDialog";
import canvasMessages from "./canvasMessages";
import contextMenuList from "./contextMenuList";
import treeRender from "./treeRender";
import nodeStyle from "./nodeStyle";

export default {
  loading: {
    text: "Loading...",
  },
  // TopSearch.vue - Top Search
  topSearch: {
    transactionTime: "Transaction Time",
    startDatePlaceholder: "Start Date",
    endDatePlaceholder: "End Date",
  },
  // setupConfigure.vue - Setup Configuration
  setupConfigure: {
    title: "Settings",
    transactionQuantityLabel: "Transaction Quantity (Single Transaction)",
    minAmountPlaceholder: "Min Amount",
    maxAmountPlaceholder: "Max Amount",
    transactionTimeLabel: "Transaction Time",
    startDatePlaceholder: "Start Date",
    endDatePlaceholder: "End Date",
    advancedSettingsTitle: "Advanced Settings",
    expandCountLabel: "Expand Counterparty Count",
    expandCountPlaceholder: "1-100",
    expandCountError: "Please enter an integer between 1-100",
    repeatAddressLabel: "Repeat Address Identifier",
    firstInflowEnable: "First Main Currency Inflow",
    cancelBtn: "Cancel",
    confirmBtn: "Confirm",
  },
  // LeftOperation.vue - Left Operation
  leftOperation: {
    settingsTooltip: "Settings",
    aiModelTooltip: "AI Model",
    investigationTooltip: "Investigation",
  },
  // BTCAddress.vue - BTC Address Details
  btcAddress: {
    title: "Address Details",
    loadingText: "Loading...",
  },
  // BottomOperation.vue - Bottom Operation
  bottomOperation: {
    backToCenterTooltip: "Back to Center",
    previousStepTooltip: "Previous Step",
    nextStepTooltip: "Next Step",
    saveCanvasTooltip: "Save Canvas",
    fullscreenTooltip: "Fullscreen",
    exitFullscreenTooltip: "Exit Fullscreen",
  },
  dialog: {
    canvasDownload: "Canvas Download",
    remark: "Remark",
    addMonitoring: "Add Monitoring",
    tip: "Tip",
  },
  tips: {
    svgViewerTip:
      "For the best viewing experience, it is recommended to open SVG files using Google Chrome or Microsoft Edge browser",
    verificationResult: "Verification result available",
    switchCurrencyWarning:
      "The current canvas will not exist after switching currency, do you need to save the canvas?",
    searchAddressWarning:
      "The search address does not exist in the canvas. A new canvas will open after searching again. Do you need to save the current canvas?",
  },
  buttons: {
    confirmDownload: "Confirm Download",
    close: "Close",
    cancel: "Cancel",
    confirm: "Confirm",
    notSave: "Don't Save",
    saveCanvas: "Save Canvas",
    closeDialog: "Close Dialog",
    viewVerification: "View Verification",
  },
  placeholders: {
    remarkInput: "Please enter remark content",
  },
  messages: {
    setupSuccess: "Setup successful",
    createCanvasSuccess: "Canvas created successfully",
    saveSuccess: "Saved successfully",
    cancelled: "Cancelled",
  },
  titles: {
    modifyInfo: "Modify Information",
  },
  canvasHeader: {
    unnamedCanvas: "Unnamed Canvas",
    singleCurrencyCanvas: "Single Currency Canvas",
    caseLabel: "Case: ",
    selectCurrencyPlaceholder: "Please select currency",
    searchPlaceholder: "Search Address/Hash",
    startAnalysis: "Start Analysis",
    shortcutKeys: "Shortcut Keys",
    svgFormat: "SVG Format",
    pngFormat: "PNG Format",
    xmindFormat: "XMIND Format",
    refresh: "Refresh",
    save: "Save",
    shortcutKeysTitle: "Canvas Shortcut Keys Guide",
    shortcuts: {
      copyNode: "Copy Node",
      previousStep: "Previous Step",
      nextStep: "Next Step",
      saveCanvas: "Save Canvas",
      createCanvas: "Create Canvas",
      nodeRemark: "Node Remark",
      viewNodeDetail: "View Node Details (Select Single Node)",
      exitFullscreen: "Exit Canvas Fullscreen",
      addMonitoring: "Add Monitoring",
    },
  },
  // modeldetail.vue - AI Model Details
  modelDetail: {
    title: "AI Model",
    loadingText: "Loading...",
    emptyText: "No Data",
    modelVerificationType: "Model Verification Type:",
    feeModel: "Fee Model",
    verificationResult: "Verification Result:",
    firstFeeSourceLevel: "First Fee Source Level:",
    feeSourceLevel: "Fee Source Level:",
    firstFeeSourcePlatform: "First Fee Source Platform:",
    firstFeeSourceAddress: "First Fee Source Address:",
    feeSourceAddress: "Fee Source Address:",
    firstFeeSourceHash: "First Fee Source Hash:",
    feeSourceHash: "Fee Source Hash:",
    firstFeeSourceTime: "First Fee Source Time:",
    feeSourceTime: "Fee Source Time:",
    firstFeeSourceQuantity: "First Fee Source Quantity:",
    feeSourceQuantity: "Fee Source Quantity:",
    ordinaryInvestigation: "Ordinary Investigation",
    keyInvestigation: "Key Investigation",
    copySuccess: "Copied Successfully!",
    addInvestigationSuccess: "Added to Investigation Successfully!",
  },
  // nodedetail.vue - Node Details
  nodeDetail: {
    loadingText: "Loading...",
    addressDetail: "Address Details",
    nodeDetail: "Node Details",
    contractDetail: "Contract Details",
    transactionStatistics: "Transaction Statistics",
    tradingOpponent: "Trading Opponent",
    tradingOpponentWithUSDT: "Trading Opponent (USDT)",
    otherInfo: "Other Info",
    assets: "Assets",
    notSupportedBlockchain:
      "The system does not support data display on this blockchain",
    addressNotFound: "Address not found",
    noTransactionData: "No transaction data for this address in the system",
  },
  polygonDialog,
  canvasMessages,
  contextMenuList,
  treeRender,
  nodeStyle,
};
